import { useEffect, useMemo } from 'react';
import type { InfiniteData } from '@tanstack/react-query';

import { useSetVehicleCount } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import type { VehicleListItem } from 'Types/vehicle';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

import { getVehiclesCount } from './useVehicleListCount.helpers';

export interface UseVehicleListCountParams {
	selectedVehicle?: VehicleListItem;
	vehicles?: InfiniteData<VehicleListFetcher>;
}

const useVehicleListCount = ({ selectedVehicle, vehicles }: UseVehicleListCountParams): number => {
	const setVehicleCount = useSetVehicleCount();

	const vehicleCount = useMemo(() => getVehiclesCount({ selectedVehicle, vehicles }), [vehicles, selectedVehicle]);

	useEffect(() => {
		setVehicleCount(vehicleCount);
	}, [vehicleCount, setVehicleCount]);

	return vehicleCount;
};

export default useVehicleListCount;
